import clusterLayers from './layers/clusterLayers';
import drawingLayers from './layers/drawingLayers';
import staticLayers from './layers/staticLayers';
import type { Feature, InitializeLayersArgs, Map } from './types';

const useLayers = () => {
    const { initialize: initializeDrawingLayers, updateFeatures: updateDrawingFeatures } =
        drawingLayers();
    const { initialize: initializeStaticLayers, updateFeatures: updateStaticFeatures } =
        staticLayers();
    const { initialize: initializeClusterLayers, updateFeatures: updateClusterFeatures } =
        clusterLayers();

    const initializeLayers = ({
        clusterStyle,
        drawingStyles,
        map,
        staticStyles,
        unclusteredStyle
    }: InitializeLayersArgs) => {
        initializeDrawingLayers(map, drawingStyles);
        initializeStaticLayers(map, staticStyles);
        initializeClusterLayers({ clusterStyle, map, unclusteredStyle });
    };

    const drawFeatures = (map?: Map, features?: Feature[]) => {
        if (!map || !features) {
            return;
        }

        updateDrawingFeatures(map, features);
        updateStaticFeatures(map, features);
        updateClusterFeatures(map, features);
    };

    return {
        drawFeatures,
        initializeLayers
    };
};

export default useLayers;
